// extracted by mini-css-extract-plugin
module.exports = {"root":"root__3HBwV","loader":"loader__3AO9T","spinner":"spinner__3B5c0","error":"error__TY2Cx"};